import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '../../styles';
import { useComboboxContext } from '../Combobox.context';
import { Typography } from '../../Typography';
export var useStyles = makeStyles(function (theme) {
    var placeholderDisabled = theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.background.b7;
    return createStyles({
        combobox: {
            marginRight: '12px',
        },
        input: {
            cursor: 'pointer',
            // Positioning context provided by inputWrap (See Combobox.tsx)
            position: 'absolute',
            height: '100%',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0,
        },
        disabled: {
            cursor: 'default',
        },
        placeholder: {
            // match default input padding
            marginLeft: '12px',
            color: function (_a) {
                var disabled = _a.disabled;
                return disabled ? placeholderDisabled : theme.palette.text.primary;
            },
        },
    });
});
export var Combobox = function (props) {
    var _a;
    var id = props.id, inputRef = props.inputRef, placeholder = props.placeholder, className = props.className, disabled = props.disabled, inputValue = props.value, inputProps = __rest(props, ["id", "inputRef", "placeholder", "className", "disabled", "value"]);
    var _b = useComboboxContext(), menuIsOpen = _b.menuIsOpen, hasFocusWithin = _b.hasFocusWithin, hasValue = _b.hasValue, comboboxProps = _b.comboboxProps;
    var floatingLabel = comboboxProps.floatingLabel;
    var classes = useStyles({ disabled: disabled });
    var showPlaceholder = placeholder && floatingLabel ? !hasValue && hasFocusWithin : !hasValue;
    return (React.createElement("div", { id: "".concat(id, "-combobox"), className: classes.combobox },
        showPlaceholder && React.createElement(Typography, { className: classes.placeholder }, placeholder),
        React.createElement("input", __assign({ id: id, ref: inputRef, role: "combobox", "aria-haspopup": "listbox", "aria-controls": menuIsOpen ? "".concat(id, "-menu") : undefined, "aria-expanded": menuIsOpen, "aria-disabled": disabled, className: clsx(className, classes.input, (_a = {}, _a[classes.disabled] = disabled, _a)), disabled: disabled }, inputProps, { "aria-describedby": "combobox-value-".concat(id) }))));
};
export default Combobox;
//# sourceMappingURL=Combobox.Combobox.js.map